import { render, staticRenderFns } from "./table_gov_body.vue?vue&type=template&id=15299dea&scoped=true&lang=pug"
import script from "./table_gov_body.vue?vue&type=script&lang=js"
export * from "./table_gov_body.vue?vue&type=script&lang=js"
import style0 from "./table_gov_body.vue.css?vue&type=style&index=0&id=15299dea&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15299dea",
  null
  
)

export default component.exports